import { Team } from '@ori/testid-generator';

/**
 * Name of this app.
 */
export const APP_NAME = 'web-messenger';

/**
 * Team which owns this SPA.
 */
export const APP_TEAM_NAME: Team = Team.Presentation;

/**
 * Serves as identifier to the root of this SPA in the HTML:
 */
export const ROOT_ELEMENT_ID = `${APP_NAME}-root`;

/**
 * Iframe id for authentication.
 */
export const AUTH_IFRAME_ID = 'GenesysAuthFrame';

/**
 * Auth Code storage parameter.
 */
export const AUTH_CODE_STORAGE_PARAMETER_FOR_GENESYS = 'genesysAuthCode';

/**
 * Issuer storage parameter.
 */
export const ISSUER_STORAGE_PARAMETER_FOR_GENESYS = 'genesysIssuer';

/**
 * Base URI for authentication.
 */
export const REDIRECT_URI_BASE = `https://clientapp-${
  process.env.NODE_ENV === 'production' ? '' : 'test-'
}cdn.oriflame.com`;

/**
 * Redirect URI for authentication.
 */
export const REDIRECT_URI = `${REDIRECT_URI_BASE}/static/web-messenger/auth-callback/index.html`;
